import Vue from "vue";
import { API_ROOT, studyManagement, users, updatepassword, studies, sites, notification, markread, userPortalNotifications, API_ROOT_V2 } from "./urls";

const editPassword = Vue.resource(`${API_ROOT}${studyManagement}${users}/${updatepassword}`, {}, { update: { method: "PUT" } });
const editProfile = Vue.resource(`${API_ROOT}${studyManagement}${users}{/id}`, {}, { update: { method: "PUT" } });

const configureSiteTeamResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${sites}{/siteId}/${users}{/userId}/${notification}`, {}, { update: { method: "PUT" } });

const saveSiteTeamResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${sites}{/siteId}/${users}{/userId}/${notification}`, {}, { update: { method: "PUT" } });

const configureStudyTeamResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${users}{/userId}/${notification}`, {}, { update: { method: "PUT" } });

const saveStudyTeamResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${users}{/userId}/${notification}`, {}, { update: { method: "PUT" } });

const readUserNotificationResource = Vue.resource(`${API_ROOT}${studyManagement}${userPortalNotifications}{/userPortalNotificationId}/${markread}`, {}, { update: { method: "PUT" } });

const profileDetails = Vue.resource(`${API_ROOT_V2}${studyManagement}${users}{/id}?studyId={studyId}`, {}, { update: { method: "PUT" } });

export function editProfileDetails(id, profile) {
  return editProfile.update({ id }, profile).then(res => res.json());
}

export function updatePasswordDetails(id, password) {
  return editPassword.update({ id }, password);
}

export function getStudyTeamNotification(userId, studyId) {
  return configureStudyTeamResource.get({ userId, studyId });
}

export function getSiteTeamNotification(studyId, siteId, userId) {
  return configureSiteTeamResource.get({ studyId, siteId, userId });
}

export function saveSiteTeamNotification(studyId, siteId, userId, notificationList) {
  return saveSiteTeamResource.save({ studyId, siteId, userId }, notificationList);
}

export function saveStudyTeamNotification(userId, studyId, notificationList) {
  return saveStudyTeamResource.save({ userId, studyId }, notificationList);
}

export function markAsReadUserNotification(userPortalNotificationId) {
  return readUserNotificationResource.save({ userPortalNotificationId }, userPortalNotificationId);
}

export function getProfileDetails(id, studyId = "") {
  return profileDetails.get({ id, studyId });
}
